import React from 'react';
import { number, object, node } from 'prop-types';
import { useTranslation } from '@airasia-common/libraries/i18n';
import Wrapper from '../Wrapper';
import Text from '../Text/Text';
import Row from '../Container/Row';
import Styled from '../../utils/Styled';
import Icon from '../Icon';

const MultiRoomCardWrapper = Styled(Wrapper, {
  border: 'none',
  borderLeft: ['none', '1px solid #DADAEC'],
});

const MultiRoomCardHeader = Styled(Row, {
  backgroundColor: 'secondaryLighter',
  borderRadius: [4, '0px 4px 4px 0px'],
  border: '1px solid',
  borderColor: '#DADAEC',
  py: [2, 3],
  px: [3, 4],
  width: 'fit-content',
  alignItems: 'center',
});

const MultiRoomCard = ({ children, roomNo, boxStyle, contentStyle }) => {
  const translate = useTranslation();
  return (
    <Wrapper {...boxStyle}>
      <MultiRoomCardHeader>
        <Wrapper background="secondary" color="secondary" marginRight={3}>
          <Icon icon="HotelIcon" fontsize="titleSmall" color="secondary" />
        </Wrapper>
        <Text
          fontSize={[14, 16]}
          color="secondary"
          lineHeight={['22px', '20px']}
          className="room-title"
        >
          {translate('common.roomIndex', { index: roomNo })}
        </Text>
      </MultiRoomCardHeader>
      <MultiRoomCardWrapper>
        <Wrapper
          paddingTop={[0, 2]}
          paddingBottom={0}
          paddingLeft={[0, 44]}
          paddingRight={0}
          {...contentStyle}
        >
          {children}
        </Wrapper>
      </MultiRoomCardWrapper>
    </Wrapper>
  );
};

MultiRoomCard.propTypes = {
  children: node,
  boxStyle: object,
  contentStyle: object,
  roomNo: number,
};

export default MultiRoomCard;
